import React, { useEffect } from 'react'
import { useHistory, useParams } from 'react-router-dom'

import UserRow, {
	UserRowSkeleton,
} from '../../components/cards/UserRow/UserRow'

import { useFetchList } from 'store'

import styles from './UsersController.module.sass'
import NoData from 'components/general/NoData/NoData'

import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import Collection from '@jimmyboys/liita-ui/dist/components/Collection'

import User from 'models/User'

const UsersController = () => {
	const { i18n, screenSize } = useGlobal()
	const params = useParams()
	const history = useHistory()

	const cardLabels = {
		noRoles: i18n`There are no roles`,
	}

	const {
		state,
		contents: [usersData],
	} = useFetchList(
		['/users'],
		[
			(userRaw) => {
				const user = User.fromJSON(userRaw)
				return {
					...user,
					$isSelected: params.userId === user.id,
					$cardName: 'UserRow',
					$cardLabels: cardLabels,
				}
			},
		]
	)

	const isLoading = state === 'loading'

	usersData?.sort((a, b) => a.name.localeCompare(b.name))

	const userIdToRedirect = !params.userId && usersData?.[0]?.id

	useEffect(() => {
		if (userIdToRedirect && screenSize !== 'small') {
			history.replace(`/users/${userIdToRedirect}/user-exclusion/`)
		}
	}, [userIdToRedirect, history, screenSize])

	return (
		<>
			{!isLoading && !usersData?.length ? (
				<NoData
					applyMaxWidth
					paddings={['normal', 'normal']}
					message={i18n`Current filters do not match any user.`}
				/>
			) : null}
			<Collection
				className={styles['users-list']}
				items={usersData || []}
				itemsHeight={parseFloat(UserRow.defaultHeight)}
				renderAhead={20}
				cards={{
					UserRow,
					UserRowSkeleton,
				}}
			/>
		</>
	)
}

export default UsersController
